import { useContext, useEffect, useState } from 'react';
import history from '@history';
import { useDispatch } from 'react-redux';
import { BootstrapContext } from 'app/bootstrap/BootstrapContext';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Controller, useForm } from 'react-hook-form';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import WdPageSimple from '@main/core/WdPageSimple';
import {
  BasicSelect,
  ButtonWithLoader,
  ComposedHeader,
  FormCardLayout,
  MetadataExpandForm,
  TextWithLabel,
} from '@main/components';
import {
  catalogAccessTypes,
  catalogBrands,
  catalogCompanies,
  catalogLocations,
  catalogModels,
  getRecognitionById,
  storeRecognition,
  updateRecognition,
} from 'src/app/api/recognition';
import _ from 'lodash';
import { regexTitle } from 'src/app/utils/validations';
import { useExtractSelector, useRequest } from '@main/hooks';
import { Autocomplete, FormControlLabel, FormLabel, Grid, Switch } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { showMessage } from 'app/store/core/messageSlice';
import { defaultValues } from '../Validators/update';

const Root = styled(WdPageSimple)(({ theme }) => ({
  backgroundColor: '#FFF',
  '& .WdPageSimple-header': {},
  '& .WdPageSimple-content': {},
}));

const schema = yup.object().shape({
  name: yup
    .string()
    .matches(regexTitle, 'El nombre no es válido.')
    .required('El nombre es obligatorio.'),
  status: yup.boolean(),
  description: yup.string(),
});

export const Update = () => {
  const dispatch = useDispatch();
  const { finalizeSession } = useContext(BootstrapContext);
  const [searchParams] = useSearchParams();
  const previousId = searchParams.get('id');

  const [metadata, setMetadata] = useState({});
  const [metadataError, setMetadataError] = useState(false);

  // ----- Inicializacion de validadores de formulario
  const { control, formState, handleSubmit, setValue } = useForm({
    mode: 'onChange',
    defaultValues,
    resolver: yupResolver(schema),
  });
  const { isValid, dirtyFields, errors } = formState;
  // ------ Request Get Admin ------
  const handleOnForbidden = async () => {
    await finalizeSession();
  };

  const handleOnError = async (message) => {
    Dispatch(showMessage({ message }));
  };
  const { makeRequest: getPreviousData, response: responsePreviousData } = useRequest(
    getRecognitionById,
    {
      onForbidden: handleOnForbidden,
      onError: handleOnError,
    }
  );
  // ------ Request Store Location ------
  const { makeRequest: tryStore, isLoading } = useRequest(storeRecognition);
  // ------ Request Update Location ------
  const { makeRequest: tryUpdate, isLoading: isLoadingLocation } = useRequest(updateRecognition);

  // ------ index Company & Location  ------
  const { dataSelect: companyDataSelect } = useExtractSelector(catalogCompanies, {
    emptyOption: false,
    label: 'label',
    value: 'value',
  });

  const { dataSelect: locationDataSelect, makeRequest: locationTryRequest } = useExtractSelector(
    catalogLocations,
    {
      autoFetch: false,
      emptyOption: false,
      label: 'label',
      value: 'value',
    }
  );

  const { dataSelect: brandDataSelect, makeRequest: brandTryrequest } = useExtractSelector(
    catalogBrands,
    {
      emptyOptions: true,
      label: 'label',
      value: 'value',
    }
  );

  const { dataSelect: modelDataSelect, makeRequest: modelTryrequest } = useExtractSelector(
    catalogModels,
    {
      emptyOptions: true,
      label: 'label',
      value: 'value',
    }
  );

  const { dataSelect: accessTypeDataSelect } = useExtractSelector(catalogAccessTypes, {
    emptyOptions: true,
    label: 'label',
    value: 'value',
  });

  const handleLoadToForm = (previousData) => {
    const result = _.omit(previousData, ['updated_at', 'created_at', 'id']);
    Object.keys(result).forEach((keyName) => {
      setValue(keyName, result[keyName], { shouldValidate: true, shouldDirty: false });
    });
  };

  useEffect(() => {
    console.log('PARAMS ', previousId);
    getPreviousData(previousId);
  }, []);

  // ------ Escucha response de request de Admin
  useEffect(() => {
    console.log(responsePreviousData);
    if (!responsePreviousData) {
      return;
    }
    handleLoadToForm(responsePreviousData);
  }, [responsePreviousData]);

  const handleUpdate = (form) => {
    const builtForm = {
      ...form,
      metadata,
    };
    console.log(JSON.stringify(builtForm, null, 3));
    console.log(previousId);
    tryUpdate(previousId, builtForm).then(({ isOk }) => {
      if (isOk) {
        dispatch(
          showMessage({
            message: 'punto de registro editada correctamente',
            autoHideDuration: 4000,
            variant: 'success',
          })
        );
        history.replace('/recognition');
      }
    });
  };

  return (
    <Root
      header={<ComposedHeader decorator="button" />}
      content={
        <Box
          className="flex justify-center items-start"
          sx={{
            width: '100%',
            height: '100%',
          }}
        >
          <FormCardLayout title="Editar punto de reconocimiento">
            <FormCardLayout.FullColum>
              <form
                name="recognitionUpdateForm"
                noValidate
                className="flex flex-col justify-center w-full"
                autoComplete="off"
              >
                <div className="flex flex-col">
                  <Controller
                    name="name"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className="mb-32"
                        label="Nombre"
                        autoFocus
                        type="text"
                        error={!!errors.name}
                        helperText={errors?.name?.message}
                        variant="outlined"
                        required
                        fullWidth
                      />
                    )}
                  />
                  <Controller
                    name="description"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        className="mb-32"
                        label="Descripción"
                        autoFocus
                        type="text"
                        error={!!errors.description}
                        helperText={errors?.description?.message}
                        variant="outlined"
                        fullWidth
                      />
                    )}
                  />
                  <Grid container spacing={3} className="mb-32">
                    <Grid item xs={12} md={4}>
                      <Controller
                        name="accessType"
                        control={control}
                        render={({ field }) => (
                          <BasicSelect
                            value={field.value}
                            onChange={(value) => field.onChange(value)}
                            data={accessTypeDataSelect}
                            error={!!errors.company_key}
                            title="Tipo de acceso"
                            size="medium"
                            fullWidth
                            helperText={errors?.accessType?.message}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <Controller
                        name="deviceId"
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Número de serie"
                            autoFocus
                            type="text"
                            error={!!errors.deviceId}
                            helperText={errors?.deviceId?.message}
                            variant="outlined"
                            fullWidth
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={3} className="mb-32">
                    <Grid item xs={12} md={6}>
                      <Controller
                        name="modelName"
                        control={control}
                        render={({ field }) => (
                          <Autocomplete
                            freeSolo
                            options={modelDataSelect}
                            value={field.value || ''}
                            onChange={(e, value) =>
                              field.onChange(typeof value === 'string' ? value : value?.label ?? '')
                            }
                            onInputChange={(e, value) => field.onChange(value)}
                            onBlur={field.onBlur}
                            getOptionLabel={(option) => {
                              return typeof option === 'string' ? option : option.label;
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Modelo del dispositivo"
                                type="text"
                                error={!!errors.modelName}
                                helperText={errors?.modelName?.message}
                                variant="outlined"
                                fullWidth
                              />
                            )}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Controller
                        name="brand"
                        control={control}
                        render={({ field }) => (
                          <BasicSelect
                            value={field.value}
                            onChange={(value) => field.onChange(value)}
                            data={brandDataSelect}
                            error={!!errors.company_key}
                            title="Marca"
                            size="medium"
                            fullWidth
                            helperText={errors?.brand?.message}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <Controller
                        name="company_key"
                        control={control}
                        render={({ field }) => (
                          <TextWithLabel title="Compañia">{field.value}</TextWithLabel>
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Controller
                        name="location_key"
                        control={control}
                        render={({ field }) => (
                          <TextWithLabel title="Locación">{field.value}</TextWithLabel>
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Controller
                        name="building_key"
                        control={control}
                        render={({ field }) => (
                          <TextWithLabel title="Edificio">{field.value}</TextWithLabel>
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Controller
                        name="zone_key"
                        control={control}
                        render={({ field }) => (
                          <TextWithLabel title="Zona">{field.value}</TextWithLabel>
                        )}
                      />
                    </Grid>
                  </Grid>

                  <Controller
                    name="status"
                    control={control}
                    className="mb-32 mt-32"
                    render={({ field }) => (
                      <div className="flex flex-col items-center m-20">
                        <FormLabel component="legend">Estatus de reconocimiento </FormLabel>
                        <FormControlLabel
                          className="mb-32"
                          control={
                            <Switch
                              checked={field.value}
                              {...field}
                              inputProps={{ 'aria-label': 'Estatus' }}
                            />
                          }
                          label={field.value ? 'Activo' : 'Inactivo'}
                        />
                      </div>
                    )}
                  />
                </div>
              </form>
            </FormCardLayout.FullColum>
            <FormCardLayout.FullColum>
              <div>
                <MetadataExpandForm
                  onChange={(metafields) => setMetadata(metafields)}
                  onError={(metaError) => setMetadataError(metaError)}
                />
              </div>
            </FormCardLayout.FullColum>
            <FormCardLayout.RowButton>
              <Button
                onClick={() => history.replace('/recognition')}
                variant="contained"
                className="w-full md:w-auto"
                color="error"
              >
                Cancelar
              </Button>
              <ButtonWithLoader
                onClick={handleSubmit(handleUpdate)}
                color="success"
                aria-label="Actualizar"
                variant="contained"
                disabled={_.isEmpty(dirtyFields) || !isValid || metadataError}
                type="submit"
                isLoading={isLoading}
              >
                Actualizar
              </ButtonWithLoader>
            </FormCardLayout.RowButton>
          </FormCardLayout>
        </Box>
      }
    />
  );
};
